/**
 * Utility functions for detecting part types (Roller, Corner, etc.)
 * Used to avoid code duplication between different components
 */

/**
 * Detects if a part name indicates a Roller type
 * @param name The part name to check
 * @returns true if the part is a Roller type
 */
export function isRollerType(name: string | null | undefined): boolean {
  if (!name) return false;
  const lowerCaseName = name.toLowerCase();
  return lowerCaseName.includes("roller");
}

/**
 * Detects if a part name indicates a Corner type
 * @param name The part name to check
 * @returns true if the part is a Corner type
 */
export function isCornerType(name: string | null | undefined): boolean {
  if (!name) return false;
  const lowerCaseName = name.toLowerCase();

  // Überprüfe auf normale Ecken (eck)
  const isCorner = lowerCaseName.includes("eck");

  // Überprüfe auf ROL-Pattern (ROL gefolgt von einer Nummer)
  const isRolPattern = /^rol\d+/i.test(name);

  return isCorner || isRolPattern;
}

/**
 * Detects if a part name indicates a CornerBrace type (L-Ecken)
 * @param name The part name to check
 * @returns true if the part is a CornerBrace type
 */
export function isCornerBraceType(name: string | null | undefined): boolean {
  if (!name) return false;
  const lowerCaseName = name.toLowerCase();

  // Identifikation für L-Ecken
  return (
    lowerCaseName.includes("eck4043") ||
    lowerCaseName.includes("eck4041") ||
    lowerCaseName.includes("eck40404") ||
    lowerCaseName.includes("eck4044")
  );
}
